import { NARROW_SCREEN_HANDLE_SIZE, WIDE_SCREEN_HANDLE_SIZE } from '../detailPanelHandleSize'
import type { TPanelLayoutArgs } from '../types'

export const getBottomPanelLayout = ({
  viewportSize,
  insets,
  isWideScreen,
  isOpen,
  draggedSize,
}: TPanelLayoutArgs) => {
  const openTop = 150 + insets.top //150 is the height of minimized side panel
  const closedTop = Math.round(viewportSize.height) - insets.bottom
  const maxSize = closedTop - openTop
  const size = isOpen ? Math.min(Math.max(draggedSize ?? maxSize, 0), maxSize) : 0
  const top = closedTop - size
  const handleSize = isWideScreen ? WIDE_SCREEN_HANDLE_SIZE : NARROW_SCREEN_HANDLE_SIZE

  return {
    placement: 'bottom' as const,
    maxSize,
    size,
    content: { top, left: 0, width: viewportSize.width, height: viewportSize.height - top },
    handle: { top: top - handleSize, left: 0, width: viewportSize.width, height: handleSize },
    tabs: { top: top - 55, left: 28, buttonWidth: 72, buttonHeight: 55 },
    childWidth: viewportSize.width,
    childHeight: viewportSize.height - openTop - insets.bottom,
  }
}
